<template>
  <div class="sectionVideo" id="video" ref="videoRef">
    <div class="mask"></div>
    <iframe
        width="100%"
        height="100%"
        title="youtubeIframe"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        :src="`https://www.youtube.com/embed/${websiteConfig.videoLink}?autoplay=true&loop=1&rel=0&controls=0&mute=1&playlist=${websiteConfig.videoLink}&enablejsapi=1`"
    >
    </iframe>

  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { point } from '@/utils/pointUtils';
import { useIntersectionObserver } from '@vueuse/core';
import websiteConfig from "@/configs/websiteConfig";
const videoRef = ref(null)
let videoViewActive = false;
useIntersectionObserver(videoRef, ([{ isIntersecting }]) => {
  if (!videoViewActive && isIntersecting) {
    videoViewActive = true;
    point({
      eventName: 'view_page',
      eventType: '视频资讯',
    });
  }
});
</script>
